// src/dates/dateFnsPassthrough.ts
import * as DateFns from "date-fns";
import { tz } from "@date-fns/tz";
var isBefore2 = DateFns.isBefore;
var isAfter2 = DateFns.isAfter;
var isEqual2 = DateFns.isEqual;
var isValid2 = DateFns.isValid;
var formatDuration2 = DateFns.formatDuration;
var getDate2 = (date, options = {}) => DateFns.getDate(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var getMonth2 = (date, options = {}) => DateFns.getMonth(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var getYear2 = (date, options = {}) => DateFns.getYear(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var endOfDay2 = (date, options = {}) => DateFns.endOfDay(date, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var lastDayOfMonth2 = (date, options = {}) => DateFns.lastDayOfMonth(date, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var startOfMonth2 = (date, options = {}) => DateFns.startOfMonth(date, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var startOfDay2 = (date, options = {}) => DateFns.startOfDay(date, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var parse2 = (dateStr, formatStr, referenceDate, options = {}) => DateFns.parse(dateStr, formatStr, referenceDate, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var parseISO2 = (argument, options = {}) => DateFns.parseISO(argument, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var add2 = (date, duration, options = {}) => DateFns.add(date, duration, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var sub2 = (date, duration, options = {}) => DateFns.sub(date, duration, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var setDate2 = (date, dayOfMonth, options = {}) => DateFns.setDate(date, dayOfMonth, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var differenceInMinutes2 = (laterDate, earlierDate, options = {}) => DateFns.differenceInMinutes(laterDate, earlierDate, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var differenceInDays2 = (laterDate, earlierDate, options = {}) => DateFns.differenceInDays(laterDate, earlierDate, {
  ...options,
  in: options.in ?? tz("UTC")
});
var format2 = (date, formatStr, options = {}) => DateFns.format(date, formatStr, {
  ...options,
  in: options.in ?? tz("UTC")
});
var formatISO2 = (date, options = {}) => DateFns.formatISO(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var formatDistanceToNow2 = (date, options = {}) => DateFns.formatDistanceToNow(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var intervalToDuration2 = (interval, options = {}) => DateFns.intervalToDuration(interval, {
  ...options,
  in: options.in ?? tz("UTC")
});
var isFirstDayOfMonth2 = (date, options = {}) => DateFns.isFirstDayOfMonth(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var isLastDayOfMonth2 = (date, options = {}) => DateFns.isLastDayOfMonth(date, {
  ...options,
  in: options.in ?? tz("UTC")
});
var isSameDay2 = (laterDate, earlierDate, options = {}) => DateFns.isSameDay(laterDate, earlierDate, {
  ...options,
  in: options.in ?? tz("UTC")
});
var formatDistanceStrict2 = (laterDate, earlierDate, options = {}) => DateFns.formatDistanceStrict(laterDate, earlierDate, {
  ...options,
  in: options.in ?? tz("UTC")
});
var endOfMonth2 = (date, options = {}) => DateFns.endOfMonth(date, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var set2 = (date, values, options = {}) => DateFns.set(date, values, {
  ...options,
  //@ts-expect-error - see note above
  in: options.in ?? tz("UTC")
});
var eachDayOfInterval2 = (interval, options = {}) => DateFns.eachDayOfInterval(interval, {
  ...options,
  in: options.in ?? tz("UTC")
});
var eachMonthOfInterval2 = (interval, options = {}) => DateFns.eachMonthOfInterval(interval, {
  ...options,
  in: options.in ?? tz("UTC")
});
var eachWeekOfInterval2 = (interval, options = {}) => DateFns.eachWeekOfInterval(interval, {
  ...options,
  in: options.in ?? tz("UTC")
});

// src/dates/dates.ts
import equals from "lodash/fp/equals";
import { match } from "ts-pattern";
var datesInSameYear = (date1, {
  localDate = true
} = {}) => (date2) => {
  if (!date1 || !date2) {
    return false;
  }
  try {
    return new Date(
      Date.parse(date1 + (localDate ? "T00:00:00.000Z" : ""))
    ).getFullYear() === new Date(
      Date.parse(date2 + (localDate ? "T00:00:00.000Z" : ""))
    ).getFullYear();
  } catch (e) {
    return false;
  }
};
var addDurations = (durationLeft, durationRight) => {
  const baseDate = /* @__PURE__ */ new Date(0);
  return intervalToDuration2({
    start: baseDate,
    end: add2(add2(baseDate, durationLeft), durationRight)
  });
};
function normalizeDuration(duration) {
  const additionalYears = Math.floor((duration.months ?? 0) / 12);
  return {
    years: (duration.years ?? 0) + additionalYears,
    months: (duration.months ?? 0) % 12,
    days: duration.days ?? 0
  };
}
function durationsMatch(duration1, duration2) {
  return equals(normalizeDuration(duration1), normalizeDuration(duration2));
}
var isoTimestampIgnoringTime = (date, type) => {
  const dd = date.getDate().toString().padStart(2, "0");
  const mm = (date.getMonth() + 1).toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  return match(type).with("start", () => `${yyyy}-${mm}-${dd}T00:00:00.000Z`).with("end", () => `${yyyy}-${mm}-${dd}T23:59:59.999Z`).exhaustive();
};
var startOfCalendarQuarter = (quarter, year = (/* @__PURE__ */ new Date()).getFullYear()) => {
  switch (quarter) {
    case 1:
      return new Date(year, 0, 1);
    case 2:
      return new Date(year, 3, 1);
    case 3:
      return new Date(year, 6, 1);
    case 4:
      return new Date(year, 9, 1);
    default:
      throw new Error(`Invalid quarter: ${quarter}`);
  }
};
var endOfCalendarQuarter = (quarter, year = (/* @__PURE__ */ new Date()).getFullYear()) => {
  switch (quarter) {
    case 1:
      return endOfMonth2(new Date(year, 2, 5));
    case 2:
      return endOfMonth2(new Date(year, 5, 5));
    case 3:
      return endOfMonth2(new Date(year, 8, 5));
    case 4:
      return endOfMonth2(new Date(year, 11, 5));
    default:
      throw new Error(`Invalid quarter: ${quarter}`);
  }
};
var previousCalendarQuarter = (year = (/* @__PURE__ */ new Date()).getFullYear()) => {
  const now = /* @__PURE__ */ new Date();
  const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
  switch (currentQuarter) {
    case 1: {
      const previousYear = year - 1;
      return [
        startOfCalendarQuarter(4, previousYear),
        endOfCalendarQuarter(4, previousYear)
      ];
    }
    default:
      return [
        startOfCalendarQuarter(currentQuarter - 1),
        endOfCalendarQuarter(currentQuarter - 1)
      ];
  }
};

// src/dates/durationToDate.adapter.ts
var durationsToDateAdapter = {
  toDate: (baseDate) => (duration) => {
    if (!baseDate) {
      return;
    }
    return add2(baseDate, duration);
  },
  toDuration: (fromDate) => (toDate) => {
    if (!fromDate || !toDate) {
      return;
    }
    const durationBetweenFromAndTo = intervalToDuration2({
      start: fromDate,
      end: toDate
    });
    const dateOfNonInclusiveMonthlyDuration = add2(fromDate, {
      years: durationBetweenFromAndTo.years ?? 0,
      months: (durationBetweenFromAndTo.months ?? 0) + 1,
      days: -1
    });
    if (isEqual2(dateOfNonInclusiveMonthlyDuration, toDate)) {
      if ((durationBetweenFromAndTo.months ?? 0) + 1 === 12) {
        return {
          years: (durationBetweenFromAndTo.years ?? 0) + 1,
          months: 0,
          days: -1
        };
      }
      return {
        years: durationBetweenFromAndTo.years ?? 0,
        months: (durationBetweenFromAndTo.months ?? 0) + 1,
        days: -1
      };
    }
    return {
      years: durationBetweenFromAndTo.years ?? 0,
      months: durationBetweenFromAndTo.months ?? 0,
      days: durationBetweenFromAndTo.days ?? 0
    };
  }
};

// src/dates/customLocales/enGbCustom.ts
import { enGB } from "date-fns/locale";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "1s",
    other: "1s"
  },
  xSeconds: {
    one: "1s",
    other: "{{count}}s"
  },
  halfAMinute: "30s",
  lessThanXMinutes: {
    one: "just now",
    other: "{{count}}m"
  },
  xMinutes: {
    one: "1m",
    other: "{{count}}m"
  },
  aboutXHours: {
    one: "1h",
    other: "{{count}}h"
  },
  xHours: {
    one: "1h",
    other: "{{count}}h"
  },
  xDays: {
    one: "1d",
    other: "{{count}}d"
  },
  aboutXWeeks: {
    one: "1w",
    other: "{{count}}w"
  },
  xWeeks: {
    one: "1w",
    other: "{{count}}w"
  },
  aboutXMonths: {
    one: "1mth",
    other: "{{count}}mo"
  },
  xMonths: {
    one: "1mth",
    other: "{{count}}mo"
  },
  aboutXYears: {
    one: "1y",
    other: "{{count}}y"
  },
  xYears: {
    one: "1y",
    other: "{{count}}y"
  },
  overXYears: {
    one: "1y",
    other: "{{count}}y"
  },
  almostXYears: {
    one: "1y",
    other: "{{count}}y"
  }
};
var formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      if (token === "lessThanXMinutes" && count === 1) {
        return result;
      }
      return result + " ago";
    }
  }
  return result;
};
var enGBCustom = {
  ...enGB,
  code: "en-GB-Custom",
  formatDistance
};

// src/dates/customLocales/index.ts
var customLocales = {
  enGb: enGBCustom
};

// src/dates/formatDateRange.ts
import { tz as tz2 } from "@date-fns/tz";
import isEqual3 from "lodash/fp/isEqual";
var formatDateRange = ({
  from,
  to,
  inTimezone = tz2("UTC"),
  formatStr: {
    year: yearFmt = "yyyy",
    month: monthFmt = "MMM",
    day: dayFmt = "d"
  } = {},
  separator = "to"
}) => {
  if (!isValid2(from) || !isValid2(to)) {
    return "Invalid date range";
  }
  const fullFormatStr = `${dayFmt} ${monthFmt} ${yearFmt}`;
  const partialFormatStr = `${dayFmt} ${monthFmt}`;
  if (isEqual3(from, to)) {
    return format2(from, fullFormatStr, {
      in: inTimezone
    });
  }
  if (getYear2(from) === getYear2(to)) {
    return `${format2(from, partialFormatStr, {
      in: inTimezone
    })} ${separator} ${format2(to, fullFormatStr, {
      in: inTimezone
    })}`;
  }
  return `${format2(from, fullFormatStr, {
    in: inTimezone
  })} ${separator} ${format2(to, fullFormatStr, {
    in: inTimezone
  })}`;
};

// src/dates/dates.constants.ts
var SECONDS = 1e3;
var MINUTES = 60 * SECONDS;
var HOURS = 60 * MINUTES;
export {
  HOURS,
  MINUTES,
  SECONDS,
  add2 as add,
  addDurations,
  customLocales,
  datesInSameYear,
  differenceInDays2 as differenceInDays,
  differenceInMinutes2 as differenceInMinutes,
  durationsMatch,
  durationsToDateAdapter,
  eachDayOfInterval2 as eachDayOfInterval,
  eachMonthOfInterval2 as eachMonthOfInterval,
  eachWeekOfInterval2 as eachWeekOfInterval,
  endOfCalendarQuarter,
  endOfDay2 as endOfDay,
  endOfMonth2 as endOfMonth,
  format2 as format,
  formatDateRange,
  formatDistanceStrict2 as formatDistanceStrict,
  formatDistanceToNow2 as formatDistanceToNow,
  formatDuration2 as formatDuration,
  formatISO2 as formatISO,
  getDate2 as getDate,
  getMonth2 as getMonth,
  getYear2 as getYear,
  intervalToDuration2 as intervalToDuration,
  isAfter2 as isAfter,
  isBefore2 as isBefore,
  isEqual2 as isEqual,
  isFirstDayOfMonth2 as isFirstDayOfMonth,
  isLastDayOfMonth2 as isLastDayOfMonth,
  isSameDay2 as isSameDay,
  isValid2 as isValid,
  isoTimestampIgnoringTime,
  lastDayOfMonth2 as lastDayOfMonth,
  normalizeDuration,
  parse2 as parse,
  parseISO2 as parseISO,
  previousCalendarQuarter,
  set2 as set,
  setDate2 as setDate,
  startOfCalendarQuarter,
  startOfDay2 as startOfDay,
  startOfMonth2 as startOfMonth,
  sub2 as sub,
  tz
};
//# sourceMappingURL=index.js.map